import React, { useState } from "react";
import {
  Box,
  Button,
  Drawer,
  Grid,
  IconButton,
  Link,
  List,
  ListItem,
  Toolbar,
  Typography,
} from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { Close as CloseIcon, Menu as MenuIcon } from "@mui/icons-material";
import logo from "../../images/greenexperience.png";

const useStyles = makeStyles((theme) => ({
  logo: {
    height: "inherit"
  },
  link: {
    margin: theme.spacing(1, 1.5),
  },
  toolbar: {
    // maxHeight: "5em",
    flexWrap: 'wrap',
    // width: "100vw",
    display: "flex",
    flexDirection: "row",
    backgroundColor: "transparent",
  },
  accordion: {
    width: "inherit"
  },
  drawerHeader: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    padding: theme.spacing(0.5, 1),
  },
}));

export default function MinNavbar() {
  const classes = useStyles();
  const [menuIsOpen, setMenuIsOpen] = useState(false);
  const closeMenu = () => setMenuIsOpen(false);

  return (<>
    <Toolbar className={classes.toolbar} style={{display: "flex"}}>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <IconButton
          className={classes.logo}
          color="inherit"
          aria-label="home"
          style={{backgroundColor: "transparent"}}
          size="large">
          <img src={logo} width={"120px"} alt="logo"/>
        </IconButton>
        <Button onClick={() => setMenuIsOpen(!menuIsOpen)}>
          <MenuIcon style={{color: "#387002"}} />
        </Button>
        {/*<Accordion className={classes.accordion} style={{backgroundColor: "transparent"}}>*/}
        {/*  <AccordionSummary*/}
        {/*    expandIcon={<MenuIcon />}*/}
        {/*    aria-controls="panel1c-content"*/}
        {/*    id="panel1c-header"*/}
        {/*  >*/}
        {/*  </AccordionSummary>*/}
        {/*  <AccordionDetails>*/}
        {/*  </AccordionDetails>*/}
        {/*</Accordion>*/}
      </Grid>
    {/*<IconButton>*/}
    {/*  <MenuIcon />*/}
    {/*</IconButton>*/}
    </Toolbar>
    <Drawer anchor="right" open={menuIsOpen} onClose={closeMenu}>
      <Box className={classes.drawerHeader}>
        <IconButton
          edge="end"
          onClick={closeMenu}
          aria-label="Cerrar menú"
          size="large"
        >
          <CloseIcon />
        </IconButton>
      </Box>
      <List component="nav" aria-label="main mailbox folders">
        <ListItem button onClick={closeMenu}>
          <Link variant="button" color="textPrimary" href="#" underline="hover" className={classes.link}>
            <Typography color="textPrimary">
              Home
            </Typography>
          </Link>
        </ListItem>

        <ListItem button onClick={closeMenu}>
          <Link variant="button" color="textPrimary" href="#services" underline="hover" className={classes.link}>
            <Typography color="textPrimary">
              servicios
            </Typography>
          </Link>
        </ListItem>

        <ListItem button onClick={closeMenu}>
          <Link variant="button" color="textPrimary" href="#residential" underline="hover" className={classes.link}>
            <Typography color="textPrimary">
              Paisajismo residencial
            </Typography>
          </Link>
        </ListItem>

        <ListItem button onClick={closeMenu}>
          <Link variant="button" color="textPrimary" href="#indoor" underline="hover" className={classes.link}>
            <Typography color="textPrimary">
              Paisajismo en oficinas y terrazas
            </Typography>
          </Link>
        </ListItem>

        <ListItem button onClick={closeMenu}>
          <Link variant="button" color="textPrimary" href="#outdoor" underline="hover" className={classes.link}>
            <Typography color="textPrimary">
              Paisajismo y mantenimientos en empresas
            </Typography>
          </Link>
        </ListItem>

        <ListItem button onClick={closeMenu}>
          <Link variant="button" color="textPrimary" href="#about-us" underline="hover" className={classes.link}>
            <Typography color="textPrimary">
              nosotros
            </Typography>
          </Link>
        </ListItem>

        <ListItem button onClick={closeMenu}>
          <Link variant="button" color="textPrimary" href="#our-clients" underline="hover" className={classes.link}>
            <Typography color="textPrimary">
              cartilla de clientes
            </Typography>
          </Link>
        </ListItem>

        <ListItem button onClick={closeMenu}>
          {/*<Link variant="button" color="textPrimary" href="#" className={classes.link}>*/}
          {/*  <Typography color="textPrimary">*/}
          {/*    contacto*/}
          {/*  </Typography>*/}
          {/*</Link>*/}
          <Button href="#contact-us" variant="outlined" className={classes.link} style={{color: "whitesmoke", backgroundColor: "#387002", borderColor: "#387002"}}>
            Contacto
          </Button>
        </ListItem>
      </List>
    </Drawer>
  </>);
}